import { Translation } from '@ps/web-shared-components';
import React from 'react';

import PayconiqLogoVertical from '../../../../../../../assets/logos/payconiq_logo_vertical.svg';
import NativeAppLink from '../../../../../../NativeAppLink/NativeAppLink';
// TODO refactor to use composition or shared.scss
import { continueButton, logo, timer } from '../PayconiqRedirect.scss';

import {
  TXTWCL_Approve_in_Payconiq_app,
  TXTWCL_Continue_to_Payconiq,
  TXTWCL_Please_go_to_the_Payconiq_app__ELL,
  TXTWCL_Session_expires_inX_N0
} from './MobileLayout.messages.json';

interface Props {
  qrCodeData: string;
  remainTime: JSX.Element;
  onFallback: Function;
  onIgnored: Function;
}

const MobileLayout = ({ qrCodeData, remainTime, onFallback, onIgnored }: Props) => (
  <>
    <Translation tagName="h2" {...TXTWCL_Approve_in_Payconiq_app} />
    <Translation tagName="p" {...TXTWCL_Please_go_to_the_Payconiq_app__ELL} />
    <div className={logo}>
      <PayconiqLogoVertical />
    </div>
    <p className={timer}>
      <Translation values={{ 0: remainTime }} {...TXTWCL_Session_expires_inX_N0} />
    </p>
    <NativeAppLink
      href={qrCodeData}
      onFallback={onFallback}
      onIgnored={onIgnored}
      translation={TXTWCL_Continue_to_Payconiq}
      className={continueButton}
    />
  </>
);

export default MobileLayout;
